import { render, staticRenderFns } from "./WebhookIntegration.vue?vue&type=template&id=4ed8aa9a&scoped=true&lang=pug&"
import script from "./WebhookIntegration.vue?vue&type=script&lang=js&"
export * from "./WebhookIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed8aa9a",
  null
  
)

/* custom blocks */
import block0 from "./WebhookIntegration.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VProgressCircular,VTextField})
